// extracted by mini-css-extract-plugin
export var root = "VXAObFd1s65IdtRVu_6g";
export var root_isError = "MzIssrnAvVuC1WrsByCq";